import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { useFestival } from "../context/FestivalContext";

// Sezione a tema in Home: mostra il birraio a tema e il messaggio della festa.
export const FestivalHero = () => {
  const { festival } = useFestival();
  if (!festival) return null;
  const accent = festival.accent || "#D47738";

  return (
    <section className="relative bg-[#0D110D] py-14 md:py-20" data-testid="festival-hero">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/10 border overflow-hidden"
          style={{ borderColor: `${accent}55` }}
        >
          <div className="relative aspect-[4/3] lg:aspect-auto bg-[#141A14] overflow-hidden">
            <img
              src={festival.image_url}
              alt={`Il mastro birraio del Vecchio Cinghiale a tema ${festival.name}`}
              className="absolute inset-0 w-full h-full object-cover"
              data-testid="festival-hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D110D]/60 via-transparent to-transparent" />
            <span
              className="absolute top-5 left-5 font-mono-accent text-[10px] uppercase tracking-[0.2em] px-4 py-2 font-semibold text-[#0D110D]"
              style={{ backgroundColor: accent }}
            >
              Edizione speciale
            </span>
          </div>

          <div className="bg-[#141A14] p-8 md:p-12 lg:p-16 flex flex-col justify-center">
            <p className="font-mono-accent text-xs uppercase tracking-[0.3em] mb-5 flex items-center gap-2" style={{ color: accent }}>
              <Sparkles className="w-4 h-4" strokeWidth={2} /> {festival.name}
            </p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.02] tracking-tight text-[#E8E2D2] mb-6">
              {festival.banner}
            </h2>
            <p className="text-[#E8E2D2]/60 leading-relaxed text-base mb-8 max-w-xl">
              Il Vecchio Cinghiale festeggia con te. Scopri le nostre birre e porta a casa la cassa giusta per l'occasione.
            </p>
            <div>
              <Link
                to="/catalogo"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#0D110D] transition-colors duration-300"
                style={{ backgroundColor: accent }}
                data-testid="festival-hero-cta"
              >
                Vai al catalogo <ArrowRight className="w-4 h-4" strokeWidth={2} />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
